import enLocale from "element-ui/lib/locale/lang/en";
import msg from "./msg/msg_en";
import productModel from "./product/index_en";
import userModel from "./user/index_en";
import orderModel from "./order/index_en";
import routerModel from "./router/index_en";
import storeModel from "./store/index_en";
const en = {
    //全局配置
    search: "search",
    reset: "reset",
    exportData: "exportData",
    add: "add",
    edit: "edit",
    view: "view",
    remove: "remove",
    batch_remove: "Batch delete",
    batch_error: "Select the row that you want to delete",
    table_operatorLabel: "operation",
    back: "back",
    search_btn1: "search",
    search_btn2: "reset",
    form_cancle: "cancel",
    form_submit: "submit",
    dialog_cancle: "cancel",
    dialog_comfirm: "confirm",
    dialog_submit: "submit",
    option_all: "all",

    // 提示
    msg: msg,
    // 商品模块
    ...productModel,
    // 用户模块
    ...userModel,
    // 订单模块
    ...orderModel,
    // 门店模块
    ...storeModel,

    // 路由
    ...routerModel,

    //局部
    status: {
        disabled: "disabled", //不可用
        abled: "abled" //可用
    },

    //elementUI
    ...enLocale
};
export default en;
